export default {
  // Nav
  "brand": "USFansLink",
  "nav.home": "Strona główna",
  "nav.categories": "Kategorie",
  "nav.guides": "Poradniki",
  "nav.faq": "FAQ",
  "nav.cta": "Zobacz arkusz",
  "nav.shoppingGuide": "Przewodnik zakupowy",

  // Hero
  "hero.badge": "Zaktualizowano na 2026",
  "hero.title": "Arkusz USFans — znaleziska, QC, W2C i poradniki zakupowe",
  "hero.subtitle": "Jedno uporządkowane miejsce, w którym znajdziesz produkty USFans, kategorie, informacje QC, linki W2C, poradniki wysyłkowe i szczere wskazówki zakupowe, zanim złożysz zamówienie.",
  "hero.search": "Szukaj kategorii, QC, W2C, wysyłki lub recenzji...",
  "hero.cta1": "Arkusz USFans",
  "hero.cta2": "Kup teraz",

  // Trust
  "trust.1": "Aktualne zasoby",
  "trust.2": "Niezależne informacje",
  "trust.3": "Poradniki dla początkujących",

  // Categories
  "categories.badge": "Kategorie produktów",
  "categories.title": "Przeglądaj kategorie produktów",
  "categories.subtitle": "Przejdź od razu do kategorii, której potrzebujesz, na stronie głównej.",
  "categories.dropdownLabel": "Wybierz kategorię",
  "categories.dropdownPlaceholder": "Wybierz kategorię do przeglądania",
  "categories.empty": "Brak kategorii pasujących do wyszukiwania.",
  "categories.visit": "Zobacz kategorię",

  // Category names
  "cat.shoes": "Buty",
  "cat.hoodies": "Bluzy / Swetry",
  "cat.tshirts": "Koszulki",
  "cat.jackets": "Kurtki",
  "cat.pants": "Spodnie / Szorty",
  "cat.headwear": "Nakrycia głowy",
  "cat.sets": "Zestawy",
  "cat.underwear": "Bielizna / Majtki",
  "cat.jersey": "Koszulka sportowa",
  "cat.accessories": "Akcesoria",
  "cat.bags": "Torby",
  "cat.belts": "Paski",
  "cat.perfumes": "Perfumy",
  "cat.other": "Inne rzeczy",

  // What Is
  "whatis.title": "Czym jest arkusz USFans?",
  "whatis.p1": "Arkusz USFans to uporządkowane źródło do odkrywania produktów, linków produktowych, informacji QC i materiałów zakupowych. Zamiast przeszukiwać porozrzucane linki, dobrze zbudowany arkusz ułatwia przeglądanie produktów, kategorii i przydatnych poradników w jednym miejscu.",
  "whatis.p2": "Niezależnie od tego, czy szukasz butów, bluz, koszulek sportowych czy akcesoriów, arkusz pomaga przejść od pomysłu na produkt do zweryfikowanego linku i jasnej listy rzeczy do sprawdzenia przed złożeniem zamówienia.",
  "whatis.cta": "Zobacz arkusz",

  // Features
  "features.title": "Wszystko, czego potrzebujesz przed zakupem",
  "features.subtitle": "Praktyczne materiały, które pomogą Ci szukać, porównywać i zamawiać z większą pewnością.",
  "feature.1.title": "Arkusz USFans",
  "feature.1.desc": "Przeglądaj uporządkowane zasoby produktowe i linki kategorii w jednym miejscu.",
  "feature.2.title": "Poradnik QC",
  "feature.2.desc": "Dowiedz się, co sprawdzać i jak czytać zdjęcia kontroli jakości przed zamówieniem.",
  "feature.3.title": "Linki W2C",
  "feature.3.desc": "Zrozum linki produktowe i zasoby W2C, aby znaleźć to, czego chcesz.",
  "feature.4.title": "Koszt wysyłki",
  "feature.4.desc": "Dowiedz się, co wpływa na końcowy koszt wysyłki i jak zaplanować budżet.",
  "feature.5.title": "Recenzja USFans",
  "feature.5.desc": "Zrozum usługę, jej działanie i ograniczenia, zanim z niej skorzystasz.",
  "feature.6.title": "Bezpieczeństwo USFans",
  "feature.6.desc": "Dowiedz się, jak ograniczyć typowe ryzyko online i robić zakupy ostrożniej.",

  // Article CTA
  "articleCta.title": "Przeczytaj pełny poradnik",
  "articleCta.subtitle": "Nowy w arkuszu USFans? Zacznij od naszego poradnika dla początkujących, aby zrozumieć, jak to wszystko działa.",
  "articleCta.button": "Przeczytaj poradnik o arkuszu USFans",
  "articleCta.note": "Poradniki • Recenzje • Wskazówki bezpieczeństwa",

  // FAQ
  "faq.title": "Najczęściej zadawane pytania",
  "faq.subtitle": "Szybkie odpowiedzi na najczęstsze pytania dotyczące arkusza USFans.",
  "faq.1.q": "Czym jest arkusz USFans?",
  "faq.1.a": "To uporządkowany zbiór linków produktowych, kategorii, informacji QC i materiałów zakupowych, który pomaga odkrywać i sprawdzać produkty przed zamówieniem.",
  "faq.2.q": "Jak działa USFans?",
  "faq.2.a": "USFans działa jak usługa zakupowa i spedycyjna. Znajdujesz link produktu, zamawiasz przez usługę, a ona pomaga w zakupie, kontroli QC i wysyłce pod Twój adres.",
  "faq.3.q": "Czy USFans jest legalne?",
  "faq.3.a": "USFans to szeroko omawiana usługa zakupowa, ale zawsze rób własny research, czytaj najnowsze opinie społeczności i weryfikuj dane sprzedawcy oraz płatności przed zamówieniem.",
  "faq.4.q": "Czy USFans jest bezpieczne?",
  "faq.4.a": "Żadne zakupy online nie są całkowicie wolne od ryzyka. Ogranicz je, sprawdzając opinie sprzedawców, potwierdzając zdjęcia QC i używając bezpiecznych metod płatności.",
  "faq.5.q": "Ile kosztuje wysyłka USFans?",
  "faq.5.a": "Koszt wysyłki zależy od wagi paczki, wymiarów, kraju docelowego i wybranej metody wysyłki. Konsolidacja może pomóc obniżyć całkowity koszt.",
  "faq.6.q": "Czym jest magazyn USFans?",
  "faq.6.a": "Magazyn przechowuje Twoje przedmioty po zakupie, tam wykonywane są zdjęcia QC i konsolidowane paczki przed wysyłką międzynarodową.",
  "faq.7.q": "Gdzie znajdę linki W2C USFans?",
  "faq.7.a": "Linki W2C są zwykle udostępniane w arkuszu lub w zasobach społeczności. Zawsze weryfikuj link przed jego użyciem.",
  "faq.8.q": "Czy dostępne są kupony USFans?",
  "faq.8.a": "Promocje i rabaty często się zmieniają. Sprawdź stronę główną, aby zobaczyć aktualne oferty, i zweryfikuj każdy kupon przed użyciem.",

  // Guides section
  "guides.badge": "Poradniki i artykuły",
  "guides.title": "Poradniki i artykuły USFans",
  "guides.subtitle": "Oryginalne, pogłębione przewodniki o recenzjach, wysyłce, QC, W2C, bezpieczeństwie i więcej.",
  "guides.readMore": "Czytaj artykuł",

  // Final CTA
  "final.title": "Gotowy, aby odkryć arkusz USFans?",
  "final.subtitle": "Przeglądaj kategorie produktów, znajdź zasoby QC i W2C i zamawiaj z jaśniejszym planem.",
  "final.button": "Odkryj arkusz USFans",

  // Footer
  "footer.tagline": "Twoje niezależne centrum zasobów o arkuszu USFans — znaleziska, QC, W2C, wysyłka i poradniki zakupowe.",
  "footer.disclaimer": "USFansLink to niezależne źródło informacji. O ile nie zaznaczono inaczej, nie jest powiązany, wspierany ani prowadzony przez USFans.",
  "footer.explore": "Przeglądaj",
  "footer.resources": "Zasoby",
  "footer.legal": "Informacje prawne",
  "footer.home": "Strona główna",
  "footer.categories": "Kategorie",
  "footer.guide": "Poradnik o arkuszu USFans",
  "footer.faq": "FAQ",
  "footer.mainSite": "Strona główna serwisu",
  "footer.privacy": "Polityka prywatności",
  "footer.terms": "Warunki korzystania",
  "footer.disclaimerTitle": "Zastrzeżenie",
  "footer.rights": "Wszelkie prawa zastrzeżone.",
};